import Swal from 'sweetalert2'
import {getTimezone, handleNotificationWithToastify} from '../../app/services/Functional'

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {
          access_token,
          user,
          active_inspection_company,
          isExpiredCompanyAPIcalling,
          expired_inspection_company,
        },
        categories: {isGlobalTemplateAPIcalling},
      } = store.getState()
      config.headers.request_from = 'web'
      config.headers.timezone = getTimezone()
      if (access_token) {
        config.headers.Authorization = `Bearer ${access_token}`
        if (user) {
          config.headers.user_id = user.id
        }
        if (active_inspection_company || expired_inspection_company) {
          config.headers.inspection_company_slug = !isGlobalTemplateAPIcalling
            ? isExpiredCompanyAPIcalling
              ? expired_inspection_company.slug
              : active_inspection_company.slug
            : 'decent'
        }
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      // if (response.data.code === 500) {
      //   handleNotificationWithToastify(response.data)
      // }
      return response
    },
    (error: any) => {
      return new Promise((resolve, reject) => {
        if (error.config && !error.config._retry) {
          if (error.status === 429) {
            const errorMsg = {
              message:
                'You’ve exceeded the allowed number of requests. Please wait a moment before trying again. (If the issue persists, contact support or refer to your usage limits.)',
              success: false,
            }
            handleNotificationWithToastify(errorMsg)
          }
          switch (error.response?.status) {
            case 401:
              window.location.href = '/logout'
              break
            case 500:
              return handleNotificationWithToastify(error.response)
            case 501:
            case 502:
              // @ts-ignore
              Swal.fire({
                title: 'Warning!',
                html: 'Server is not reachable',
                icon: 'warning',
                allowOutsideClick: false,
                buttons: {
                  confirm: {
                    text: 'Re-Try',
                    value: true,
                    visible: true,
                    className: '',
                    closeModal: true,
                  },
                },
              }).then(() => {
                window.location.reload()
              })
              break

            default:
              break
          }
        }
        return reject(error)
      })
    }
  )
}
